import {Event} from "@app/core/tracking/domain/event";

/**
 * Event triggered when a client accesses the Coupons section.
 */
export class CouponsViewedEvent extends Event {
}